import theme from '@styles/theme';
export default {
  container: {
    width: '100%',
    height: 'auto',
    backgroundColor: theme.rawColors.beige500,
    p: ['64px 16px', '64px 16px', '64px 16px', '80px 40px'],
    h2: {
      p: ['0 24px 40px', '0 24px 40px', '0 24px 40px', '0 115px 48px 115px']
    }
  },
  servicesContainer: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexFlow: 'row wrap',
    alignContent: 'space-between',
    justifyContent: 'space-between',
    rowGap: ['16px', '24px', '24px', '24px', '140px']
  },
  item: {
    flex: '1 0 18%',
    widtht: 'auto',
    minWidth: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    alignItems: 'center',
    justifyContent: 'center',
    '.icon': {
      mb: '16px'
    },
    p: {
      font: theme.fonts.uniformMedium,
      fontSize: theme.fontSizes.text,
      textAlign: 'center'
    }
  }
};